import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css'; 
import DataTable from "react-data-table-component";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch,faEdit, faDeleteLeft} from "@fortawesome/free-solid-svg-icons";
import "assets/css/grid.css";
import { useListarUsuariosConsultantes } from '../../hooks/useListarUsuariosConsultante';

function UsuarioConsultanteGrid(){
const columnas=[
    {
        name:'Nro',
        selector: row => row.Id,
        sorteable:true,
        omit:true
    },
    {
        name:'Nombre',
        selector: row => row.NombreCompleto,
        sorteable:true,
    
    },
    {
        name:'Telefono',
        selector:row => row.Telefono,
        sorteable:true
    },
    {
        name:'Correo',
        selector:row => row.Correo,
        sorteable:true,
        right:true
    },
    {
        name:'Acciones',
		cell: row => (
            <>
            <a href={'FichaUsuarioConsultante/'+row.Id} rel="noopener noreferrer" title='Visualizar/editar'>
            	<FontAwesomeIcon icon={faEdit}  />
            </a>
            &nbsp;&nbsp;&nbsp;
            <a href="#" onClick={event=>onDisabled(row.Id)} rel="noopener noreferrer" title='Deshabilitar'>
            	<FontAwesomeIcon icon={faDeleteLeft} />
            </a>
            </>       
        )
    }
];
const paginacionOpciones={
    rowsPerPageText:'Número elementos',
    rangeSeparatorText:'de',
    selectAllRowsItemsText:'Todos'
}
const onDisabled=async n=>{
    
    confirmAlert({
        title: '',
        message: '¿Seguro desea deshabilitar al usuario consultante?',
        buttons: [
          {
            label: 'Si',
            onClick: () => disabledFichaConsultante(n)
          },
          {
            label: 'No'
            
          }
        ]
      });

}


 //function UsuarioConsultanteGrid(){
    const { usuariosConsultantes,getUsuariosConsultantes, disabledFichaConsultante } = useListarUsuariosConsultantes();
    const onChange=async e=>{
        e.persist();
        if(e.target.value.length>3){
            getUsuariosConsultantes(e.target.value);
        }
        else if(e.target.value.length==0){
            getUsuariosConsultantes();
        }
    }
   
   

        return (
            <div className='table-responsive'>
                <div className='barraBusqueda'>
                    <input
                        type="text"
                        placeholder="Buscar"
                        className="textField"
                        name="busqueda"
                        onChange={onChange}

                        
                    />
                    <button type='button' className='btnBuscar'>
                        <FontAwesomeIcon icon={faSearch} />
                    </button>
                </div>

            <DataTable
                columns={columnas}
                data={usuariosConsultantes}
                pagination
                paginationComponentOptions={paginacionOpciones}
                fixedHeader
                fixedHeaderScrollHeight='600px'
                noDataComponent="No hay elementos para mostrar"
                striped={true}
                
            />
            </div>


        )

    
}
export default UsuarioConsultanteGrid;

